import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { NO, NONE, UNLIMITED, VALUE, YES } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
    moduleIds,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
    Input,
} from "client/components"

const Lifecycle = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        lifecycleModuleAccess,
        lifecycles,
        lifecyclesValue,
        subLifecycles,
        subLifecyclesValue,
    } = settings

    return (
        <Collapse
            show={show}
            title={moduleList[moduleIds.lifecycle].name}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.lifecycleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={lifecycleModuleAccess === NO}
                            onChange={() => onChange({ lifecycleModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={lifecycleModuleAccess === YES}
                            onChange={() => onChange({ lifecycleModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.lifecycles}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={lifecycles === NONE}
                            onChange={() => onChange({ lifecycles: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={lifecycles === VALUE}
                            onChange={() => onChange({ lifecycles: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={lifecyclesValue}
                                    onChange={(e) => onChange({ lifecyclesValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={lifecycles === UNLIMITED}
                            onChange={() => onChange({ lifecycles: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.subLifecycles}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={subLifecycles === NONE}
                            onChange={() => onChange({ subLifecycles: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={subLifecycles === VALUE}
                            onChange={() => onChange({ subLifecycles: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={subLifecyclesValue}
                                    onChange={(e) => onChange({ subLifecyclesValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={subLifecycles === UNLIMITED}
                            onChange={() => onChange({ subLifecycles: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Lifecycle
